import React, { useState, useRef, useEffect, useCallback } from 'react';
import './ImageComparisonSlider.css';

const ImageComparisonSlider = ({ beforeImage, afterImage, beforeLabel, afterLabel }) => {
  const [sliderPosition, setSliderPosition] = useState(50);
  const containerRef = useRef(null);
  const isDragging = useRef(false);

  const updateSliderPosition = useCallback((clientX) => {
    if (!containerRef.current) return;

    const rect = containerRef.current.getBoundingClientRect();
    const x = clientX - rect.left;
    const position = (x / rect.width) * 100;
    setSliderPosition(Math.min(Math.max(position, 0), 100));
  }, []);

  const handleStart = useCallback((e) => {
    isDragging.current = true;
    const clientX = e.type === 'touchstart' ? e.touches[0].clientX : e.clientX;
    updateSliderPosition(clientX);
  }, [updateSliderPosition]);

  const handleMove = useCallback((e) => {
    if (isDragging.current) {
      const clientX = e.type === 'touchmove' ? e.touches[0].clientX : e.clientX;
      updateSliderPosition(clientX);
    }
  }, [updateSliderPosition]);

  const handleEnd = useCallback(() => {
    isDragging.current = false;
  }, []);

  useEffect(() => {
    document.addEventListener('mousemove', handleMove);
    document.addEventListener('mouseup', handleEnd);
    document.addEventListener('touchmove', handleMove, { passive: false });
    document.addEventListener('touchend', handleEnd);

    return () => {
      document.removeEventListener('mousemove', handleMove);
      document.removeEventListener('mouseup', handleEnd);
      document.removeEventListener('touchmove', handleMove);
      document.removeEventListener('touchend', handleEnd);
    };
  }, [handleMove, handleEnd]);

  return (
    <div
      className="image-comparison-container"
      ref={containerRef}
      onMouseDown={handleStart}
      onTouchStart={handleStart}
    >
      <div className="image-comparison-wrapper">
        <img
          src={beforeImage}
          alt="Before"
          className="image-comparison-before"
        />
        <div
          className="image-comparison-after"
          style={{ clipPath: `inset(0 0 0 ${sliderPosition}%)` }}
        >
          <img
            src={afterImage}
            alt="After"
          />
        </div>
        <div
          className="image-comparison-slider"
          style={{ left: `${sliderPosition}%` }}
        >
          <div className="slider-handle"></div>
        </div>
      </div>
      <div className="image-comparison-labels">
        <span className="before-label">{beforeLabel}</span>
        <span className="after-label">{afterLabel}</span>
      </div>
    </div>
  );
};

export default ImageComparisonSlider; 